var React = require('react');

function Versioning (props) {
    return React.createElement("svg",props,React.createElement("g",{"transform":"translate(2.000000, 2.000000)","strokeWidth":"3"},[React.createElement("circle",{"cx":"13.5","cy":"13.5","r":"13.5","key":0}),React.createElement("polyline",{"points":"13 6 13 14.25 19 17","key":1})]));
}

Versioning.defaultProps = {"fill":"none","stroke":"currentColor","viewBox":"0 0 31 31"};

module.exports = Versioning;

Versioning.default = Versioning;
